const NodeWebSocket = require('ws')
const WS = typeof window !== 'undefined' ? WebSocket : NodeWebSocket
import { sleep } from "@/init";

export class webSocketObj {
    stream
    isOpen = false
    callbacks = {}
    constructor(url) {
        this.stream = new WS(url)

        // Event stream
        this.stream.onopen = async () => {
            this.isOpen = true
            console.log('[socket] Connected to exchange')

        }
        this.stream.onclose = () => console.log('[socket] Connected closed')

        this.stream.onmessage = (message) => {
            let data = JSON.parse(message.data)
            for (const key in this.callbacks) {
                if (this.callbacks[key]) {
                    this.callbacks[key](data)
                }
            }
        }
        this.stream.onerror = (err) => console.error(err)
    }

    addCallback (k, c) {
        this.callbacks[k] = c
    }
    async send (subscribeMessage) {
        if (!this.isOpen) {
            await sleep(2000)
        }

        if (Array.isArray(subscribeMessage)) {
            for (let i = 0; i < subscribeMessage.length; i++) {
                this.stream.send(JSON.stringify(subscribeMessage[i]));
            }
        } else {
            this.stream.send(JSON.stringify(subscribeMessage));
        }
    }

}
